import { useSubsequentEffect } from '@carvana/vdp-react-hooks';
import Router from 'next/router';
import { useContext, useEffect } from 'react';
import { MAX_PAGE_SIZE_DEFAULT } from '~/constants';
import SearchContext from '~/contexts/SearchContext';
import { useUserData } from '~/contexts/UserContext';
import useGenerateInventoryRequest from '~/hooks/useGenerateInventoryRequest';

export default function useShowFinance(): void {
  const { setShowFinance, showFinance } = useContext(SearchContext);
  const { isLoggedIn } = useUserData();

  const inventoryRequest = useGenerateInventoryRequest(MAX_PAGE_SIZE_DEFAULT, {
    includeAnalyticsData: false
  });

  // Remove UTM parameter from URL, so it does not persist if the user navigates and comes back.
  useEffect(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete('utm_term');

    void Router.push(url, undefined, { shallow: true });
  }, [showFinance]);

  // Authenticated users should always see financing.
  useEffect(() => {
    if (isLoggedIn) setShowFinance(true);
  }, [isLoggedIn, setShowFinance]);

  // After the user interacts with the page, advertising financing to them is fair game.
  useSubsequentEffect(() => {
    setShowFinance(true);
  }, [inventoryRequest, setShowFinance]);
}
